import Tracked from '~/components/Tracked';
import ColourCheckbox from '~/legacy/components/ColourCheckbox';
import type { CategoryListProps } from '~/legacy/types';
import type { TrackedButtonClickName } from '~/services/gtm.client';

const CategoryList = ({
  title,
  children,
  parentLink,
  isVertical = false,
  hideTrailingSlash = false
}: CategoryListProps) => (
  <div className="main-header__sub-nav-list__categoryItem">
    <div className="main-header__sub-nav-list__categoryItem__title">
      {title}
    </div>
    {title !== 'Colour' &&
      children.map((item) => (
        <Tracked.ExternalLink
          href={`${parentLink}/${item.slug}/`}
          className="main-header__sub-nav-list__categoryItem__link"
          key={`${parentLink}/${item.slug}/`}
          name={item.name as TrackedButtonClickName}
          variant="none"
          pagePosition="Header"
        >
          {item.name}
        </Tracked.ExternalLink>
      ))}
    {title === 'Colour' && (
      <div
        className={`main-header__sub-nav-list__categoryItem__colour-list${
          isVertical ? '-vertical' : ''
        }`}
      >
        {children.map((item) => (
          <Tracked.ExternalLink
            href={`${parentLink}/${item.slug}${!hideTrailingSlash ? '/' : ''}`}
            className="main-header__sub-nav-list__categoryItem__link"
            key={`${parentLink}/${item.slug}/`}
            name={item.name as TrackedButtonClickName}
            variant="none"
            pagePosition="Header"
          >
            <div style={{ marginRight: '10px', marginTop: '5px' }}>
              <ColourCheckbox isRefined={false} fill={item.colour} />
            </div>
            {item.name}
          </Tracked.ExternalLink>
        ))}
      </div>
    )}
  </div>
);

export default CategoryList;
